import type { ActivityConfig } from "../types";

import bgImage from "@/assets/images/activity/2026/springRenewal/bg.webp";
import freePackageImage1 from "@/assets/images/activity/2026/springRenewal/package-free-00-1.webp";
import freePackageImage2 from "@/assets/images/activity/2026/springRenewal/package-free-00-2.webp";
import freePackageImage3 from "@/assets/images/activity/2026/springRenewal/package-free-00-3.webp";
import vipPackageImage1 from "@/assets/images/activity/2026/springRenewal/package-vip-00-1.webp";
import vipPackageImage2 from "@/assets/images/activity/2026/springRenewal/package-vip-00-2.webp";
import vipPackageImage3 from "@/assets/images/activity/2026/springRenewal/package-vip-00-3.webp";
import vipPackageImage4 from "@/assets/images/activity/2026/springRenewal/package-vip-00-4.webp";
import svipPackageImage1 from "@/assets/images/activity/2026/springRenewal/package-svip-00-1.webp";
import svipPackageImage2 from "@/assets/images/activity/2026/springRenewal/package-svip-00-2.webp";
import svipPackageImage3 from "@/assets/images/activity/2026/springRenewal/package-svip-00-3.webp";
import svipPackageImage4 from "@/assets/images/activity/2026/springRenewal/package-svip-00-4.webp";
import { ACTIVITY_TYPE } from "@/constants/activity";

/**
 * 春季焕新活动配置
 * 从 VipPackageActivity 组件提取，保证切回 free_canvas 时可完整回退。
 */
export const springRenewalConfig: ActivityConfig = {
  activityType: ACTIVITY_TYPE.FREE_CANVAS,
  backgroundImage: bgImage,
  tabOptions: [
    { label: "连续包月", value: "subscribe", discountBadge: "特价 ¥39" },
    { label: "按季购买", value: "season", discountBadge: "6.5折" },
    { label: "按年购买", value: "year", discountBadge: "6折" },
    { label: "团队使用", value: "group" }
  ],
  images: {
    free: {
      subscribe: freePackageImage1,
      season: freePackageImage2,
      year: freePackageImage3
    },
    vip: {
      subscribe: vipPackageImage1,
      subscribeParticipated: vipPackageImage4,
      season: vipPackageImage2,
      year: vipPackageImage3
    },
    svip: {
      subscribe: svipPackageImage1,
      subscribeParticipated: svipPackageImage4,
      season: svipPackageImage2,
      year: svipPackageImage3
    }
  },
  discountLabels: {
    subscribe: "限时6折",
    season: "限时55折",
    year: "限时5折"
  },
  pricingTable: {
    subscribe: {
      neverPaid: { type: "multiplier", value: 0.39 },
      activeVipSvip: { type: "multiplier", value: 0.39 },
      expired: { type: "multiplier", value: 0.39 }
    },
    season: {
      neverPaid: { type: "multiplier", value: 0.65 },
      activeVipSvip: { type: "multiplier", value: 0.65 },
      expired: { type: "multiplier", value: 0.65 }
    },
    year: {
      neverPaid: { type: "multiplier", value: 0.6 },
      activeVipSvip: { type: "multiplier", value: 0.6 },
      expired: { type: "multiplier", value: 0.6 }
    }
  }
};
